var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      style: { width: "100%", height: "100%", backgroundColor: "#EDF2FB" },
      attrs: { position: "bottom", "get-container": "body" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("van-nav-bar", {
        attrs: { title: _vm.titleText, "left-arrow": "" },
        on: {
          "click-left": function ($event) {
            _vm.show = false
          },
        },
      }),
      _vm._v(" "),
      _c(
        "van-steps",
        { attrs: { direction: "vertical", active: _vm.active } },
        _vm._l(_vm.opts, function (option, index) {
          return _c("van-step", { key: index, staticClass: "step is-card" }, [
            _c("p", { staticClass: "step-time" }, [
              _vm._v(_vm._s(option.time)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-title" }, [
              _vm._v(_vm._s(option.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-desc" }, [
              _c("div", [
                _vm._v(_vm._s(_vm.assigneeText)),
                _c("span", [_vm._v(_vm._s(option.assignee))]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.durationText)),
                _c("span", [_vm._v(_vm._s(option.duration))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-status" }, [
              _vm._v(_vm._s(option.type)),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "circle-container active-icon",
              attrs: { slot: "active-icon" },
              slot: "active-icon",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "circle-container inactive-icon",
              attrs: { slot: "inactive-icon" },
              slot: "inactive-icon",
            }),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }